import React from 'react';
import { Bone, Card, Row, Col, Container } from './SkeletonPulse';

const TimelineNode = ({ active }) => (
  <Row gap={14} align="flex-start">
    {/* Circle + connector column */}
    <Col gap={0} align="center" style={{ alignItems: 'center' }}>
      <Bone circle height={52} style={{ opacity: active ? 1 : 0.5 }} />
      <div style={{ width: 2, height: 40, background: 'var(--c-border, #e0ddd6)' }} />
    </Col>
    {/* Text block */}
    <Col gap={6} style={{ flex: 1, paddingTop: 8 }}>
      <Bone width={60} height={16} radius={10} />
      <Bone width="80%" height={15} />
      <Bone width="60%" height={12} />
    </Col>
  </Row>
);

const GestureItem = () => (
  <Card style={{ padding: '12px 14px', borderRadius: 14 }}>
    <Row gap={10}>
      <Bone circle height={18} />
      <Col gap={5} style={{ flex: 1 }}>
        <Bone width="75%" height={13} />
        <Bone width="40%" height={11} />
      </Col>
    </Row>
  </Card>
);

const PlanSkeleton = () => (
  <Container style={{ paddingTop: 12, paddingBottom: 40 }}>
    {/* Section title */}
    <Bone width={120} height={14} style={{ marginBottom: 20 }} />

    {/* Timeline phases */}
    <Col gap={0} style={{ marginBottom: 28 }}>
      <TimelineNode active />
      <TimelineNode />
      <TimelineNode />
    </Col>

    {/* Recent gestures title */}
    <Bone width={140} height={14} style={{ marginBottom: 12 }} />

    {/* Gesture list */}
    <Col gap={10}>
      <GestureItem />
      <GestureItem />
      <GestureItem />
      <GestureItem />
    </Col>
  </Container>
);

export default PlanSkeleton;
